import React, {Component} from 'react';
import {connect} from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from 'primereact/dropdown';
import {Calendar} from 'primereact/calendar';
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';

import {ROLES_SUBMENU_ID} from '../../shared/Config';
import {HASACCESS} from '../../shared/utility'
import * as actions from '../../store/actions/index';
import axios from '../../axios-url';


class SapIdoc extends Component {
    state = {
        display : true,
        globalFilter: null,
        selectedCustomers:[],
        inboundOrOutbound: null,
        selectedApproval: [],
        requestType:null
    }
    

    deleteDocType = () => {

        if(this.state.selectedCustomers.length > 0){


        const updatedDocValue = this.state.selectedCustomers.map( value => {
            return value.code;
        })
        const filteredValue = this.state.dataTableValue.filter(doc => {

            return updatedDocValue.includes(doc.code) === false;
         
        });
        this.setState({dataTableValue:filteredValue})
        }
        else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select checkbox'});
        }

    }

    componentDidMount() {
        this.loadData();
    }

    getDateOnFormat = (date) => {
        return date && date.getFullYear() + "/" + (date.getMonth() + 1).toString().padStart(2, "0") + "/" + date.getDate().toString().padStart(2, "0");
    }

    getCurrentDate(separator='',increment=0){

        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1 ;
        let year = newDate.getFullYear() - increment;
        
        return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date}`
        }

    loadData(){
        let fromDate = this.getDateOnFormat(this.state.fromDate);
        let toDate = this.getDateOnFormat(this.state.toDate);
        if (typeof toDate === 'undefined')
        {
            toDate = this.getCurrentDate();
            fromDate = this.getCurrentDate('',1)
            }
        console.log(fromDate);
        console.log(toDate);
        //this.props.getMasterTableList(`GetIdocError?InboundOrOutbound=${this.state.inboundOrOutbound}&Request_Type=${this.state.requestType}&FromDate=${fromDate}&ToDate=${toDate}`);
        this.props.getMasterTableList(`GetIdocError?FromDate=${fromDate}&ToDate=${toDate}`);
    }

    handleApprove() {
        const { selectedApproval = [] } = this.state;
        if (selectedApproval.length > 0) {
            this.setState({ loading: true });
            const submitData = Object.assign({}, {
                key: JSON.stringify({"Requestnum":selectedApproval.reduce((a, el) => {
                    const data = Object.assign({}, {
         //               Requestnumber: el.docNumber,
                        id:el.id
                    });
                    a.push(data);
                    return a;
                }, [])})
            });
            
            axios.post(`master/api/Employee/idocretry`, submitData)
                .then(response => {
                    this.setState({ loading: false });
                    this.growl.show({ severity: 'success', summary: null, detail: response.data.message });
                    this.loadData();
                    setTimeout(()=> window.location.reload(), 1000);
                }).catch(err => {
                    this.setState({ loading: false });
                    this.growl.show({ severity: 'error', summary: null, detail: 'Approval api Failed' });
                })
            } else {
            this.growl.show({ severity: 'error', summary: null, detail: 'Please select data' });
        }

    }

    render() { 
        


        let inboundOutboundOptions = [
            {label:'Inbound', value:'inbound'},
            {label:'Outbound', value:'outbound'}];

        let tableData = [];
        tableData = this.props.tableLists;

        let roleLists = null;
        if(this.props.roleLists && this.props.roleLists.length > 0){
            roleLists = this.props.roleLists.map( role => {
                return { label : role.text, value : role.id}
            });
        }

        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        let requestTypeOptions = [
            {label:"Clock", value:'CLO'},
            {label:"Document", value:'DOC'},
            {label:"Hire", value:'HIR'},
            {label:"Leave", value:'LV'},
            {label:"Travel Claim", value:'TCL'},
            {label:"Promotion", value:'PRO'},
            {label:"Document", value: 'TRA' },
            {label:"ExpenseClaim", value:'EXP'},
         ]
        
       

        return (
            <div className="p-grid approvalPath">
                <Toast ref={(el) => this.growl = el} />
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>SAP IDOC Inbound/Outbound Log</h1>
               
                        <div className="p-grid">

                        {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Inbound/Outbound<span className="requiredColor">*</span></label>
                            <div className="mt1 ">
                            <Dropdown style={{width: '100%'}} placeholder="Inbound/Outbound" value={this.state.inboundOrOutbound} options={inboundOutboundOptions} showClear onChange={(e) =>this.setState({inboundOrOutbound: e.target.value})} />
                            </div>                                
                        </div> */}

                        {/* <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Request Type<span className="requiredColor">*</span></label>
                            <div className="mt1 ">
                            <Dropdown style={{width: '100%'}} placeholder="Request Type" value={this.state.requestType} options={requestTypeOptions} showClear onChange={(e) =>this.setState({requestType: e.target.value})} />
                            </div>                                
                        </div> */}

                                
                        <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">From Date<span className="requiredColor">*</span></label>
                            <div className="mt1">
                            <Calendar    style={{width:'100%'}} placeholder="From Date" showIcon={true} name="fromDate" value={this.state.fromDate} onChange={(e) => this.setState({fromDate:e.target.value})} />
                            </div>                                
                        </div>


                        <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">To Date<span className="requiredColor">*</span></label>
                            <div className="mt1">
                            <Calendar   style={{width:'100%'}} placeholder="To Date" showIcon={true} name="toDate" value={this.state.toDate} onChange={(e) => this.setState({toDate:e.target.value})}  />
                            </div>                                
                        </div>


                            <div className="p-col-12 p-lg-12">

                                <div className="mt1">
                                    <Button  style={{float: 'right'}} label="View" className="p-button-primary" onClick={() => {this.loadData()}
                                    }/>
                                </div>   
                                <div className="p-line-down">
                                </div> 
                                <div className="mt1">
                                    <Button  style={{float: 'right'}} label="ReSubmit" className="p-button-primary" onClick={() => {this.handleApprove()}
                                    }/>
                                </div>   

                          
                            </div>

                           					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                     
                        <DataTable ref={(el) => this.dt = el} value={tableData} responsive className="p-datatable-customers animated fadeIn" rowHover 
                         selection={this.state.selectedApproval} onSelectionChange={e => this.setState({selectedApproval: e.value})}
                         paginator rows={30} emptyMessage="No data found" globalFilter={this.state.globalFilter} header={header}  >
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                <Column field="transactiontype" header="Inbound / Outbound" />
                                <Column field="docType" header="Document Type" sortable={true} />
                                <Column field="docNumber" header="Document Number" sortable={true} />
                                <Column field="id" header="IDOC Number" sortable={true} />
                                <Column field="employeeId" header="Employee ID" sortable={true} />
                                <Column field="infty" header="Info Type" sortable={true} />
                                <Column field="subty" header="Sub Type" sortable={true} />
                                <Column field="begda" header="Beginning Date" sortable={true} />
                                <Column field="endda" header="End Date" sortable={true} />
                                <Column field="message" header="Error Description" sortable={true} />
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}



const mapStateToProps = state => {
    return{
        Employee : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists,
        subordinatesListData: state.master.subordinatesListData,
        roleLists: state.master.keywordValuesList,
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues : (keyword) => dispatch(actions.getKeywordValues(keyword)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(SapIdoc);